module.exports = __webpack_public_path__ + "static/media/form-section.b143fb34.png";